export const BOTS = [
  {
    id: 'bot1',
    name: 'Emma_Frost',
    emoji: '👩‍🦳',
    level: 7
  },
  {
    id: 'bot2',
    name: 'Carlos87',
    emoji: '👨',
    level: 6
  },
  {
    id: 'bot3',
    name: 'IceMaster',
    emoji: '🧊',
    level: 5
  },
  {
    id: 'bot4',
    name: 'Sophia',
    emoji: '👩‍🦰',
    level: 5
  },
  {
    id: 'bot5',
    name: 'WinterWarrior',
    emoji: '⚔️',
    level: 4
  },
  {
    id: 'bot6',
    name: 'ahmed_k',
    emoji: '👨‍💻',
    level: 4
  },
  {
    id: 'bot7',
    name: 'Мария',
    emoji: '🧣',
    level: 3
  },
  {
    id: 'bot8',
    name: 'FIRE_KING',
    emoji: '🔥',
    level: 3
  },
  {
    id: 'bot9',
    name: 'sakura花',
    emoji: '🌸',
    level: 2
  },
  {
    id: 'bot10',
    name: 'CampChef2023',
    emoji: '👨‍🍳',
    level: 2
  },
  {
    id: 'bot11',
    name: 'snow.bunny',
    emoji: '🐰',
    level: 1
  },
  {
    id: 'bot12',
    name: 'João P.',
    emoji: '🧔',
    level: 1
  }
];
